import { Alert } from "@mui/material";
import { NoticeBannerConfig } from "interfaces/MemberPortalConfig";
import React, { FC, memo } from "react";

export type NoticeBannerProps = {
  notice: NoticeBannerConfig;
};

export const NoticeBanner: FC<NoticeBannerProps> = memo(({ notice }) => (
  <Alert severity={notice.type}>
    <strong>{notice.title}</strong> {notice.description}
  </Alert>
));
